import React from 'react';
import ServiceGrid from './services/ServiceGrid';
import SectionLabel from './common/SectionLabel';

const Services = () => {
  return (
    <section id="services" className="relative bg-black">
      <div className="container relative z-10 mx-auto px-4">
        <div className="mb-12 max-w-3xl">
          <SectionLabel>Services</SectionLabel>
          <h2 className="mt-6 text-4xl text-white md:text-5xl">Our Services</h2>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-[#d0d0d0] md:text-base">
            From custom website design to strategic marketing and operations optimization,
            our services are designed to meet your unique needs and help you succeed online.
          </p>
        </div>

        <ServiceGrid />
      </div>
    </section>
  );
};

export default Services;